<template>

  <v-container>

    <v-row align="center" justify="center" style="height:50vh" v-if="!message">
      <v-col md="4"  >
        <h2 style="padding-bottom: 1em"> {{$t('shared.resetPasswordAction')}}</h2>

        <validation-observer ref="observer">
          <v-form @submit.prevent="submit">
            <validation-provider v-slot="{ errors }" name="Name" rules="required|email" v-if="!token">
              <v-text-field
                      v-model="email"
                      :error-messages="errors"
                      label="Email *"
                      required
                      outlined
                      filled
                      dense
              ></v-text-field>
            </validation-provider>

            <validation-provider v-slot="{ errors }" name="email" rules="required" v-if="token">
              <v-text-field
                      v-model="password"
                      :error-messages="errors"
                      :label="$t('shared.login.pass')"
                      :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="showPass = !showPass"
                      required
                      outlined
                      dense
                      filled
                      :type="showPass ? 'text' : 'password'"
              ></v-text-field>
            </validation-provider>

            <div class="text-center">
              <v-btn class="signin-btn" type="submit" rounded color="primary">
                {{$t('shared.resetPasswordAction')}}
              </v-btn>
              <br>
              <router-link to="login">{{$t('shared.login.action')}}</router-link>
            </div>
          </v-form>
        </validation-observer>
      </v-col>
    </v-row>


    <v-row align="center" justify="center" style="height:50vh" v-if="message">
      <v-col md="4"  >
        {{message}}
        <br>
        <router-link to="login">{{$t('shared.login.action')}}</router-link>
      </v-col>
    </v-row>


  </v-container>
</template>

<script>

  import moment from 'moment'
  import { required, email } from 'vee-validate/dist/rules'
  import { extend, ValidationProvider, setInteractionMode, ValidationObserver } from 'vee-validate'
  import { UsersApi } from '../../../shared/services/api/users'

  setInteractionMode('eager')

  extend('required', {
    ...required,
    message: '{_field_} can not be empty'
  })

  extend('email', {
    ...email,
    message: 'Email must be valid'
  })

  export default {
    name: 'ResetPasswordPage',
    components: {
      ValidationProvider,
      ValidationObserver
    },
    data: () => ({
      email: '',
      password: null,
      token: null,
      id: null,
      showPass: false,
      message: '',
    }),
    methods: {
      async submit () {
        const valid = await this.$refs.observer.validate()
        if (valid) {
          if (this.token) {
            this.passwordChange()
          } else {
            this.passwordRequest()
          }
        }
      },
      passwordRequest () {
        console.debug("passwordRequest", this.params.email)
        UsersApi.resetPasswordRequest(this.params.email)
          .then(data => {
            this.message= i18n.t("shared.resetPasswordOK");
          })
          .catch(error => {
            this.message= i18n.t("shared.resetPasswordKO");
          })

      },
      passwordChange () {
        console.debug("passwordChange", this.params)
        UsersApi.resetPassword(this.params)
          .then(data => {
            this.message= i18n.t("shared.resetPasswordChanged");
          })
          .catch(error => {
            this.message= i18n.t("shared.resetPasswordKO");
          })
      }
    },
    computed: {
      params () {
        return {
          email: this.email,
          password: this.password,
          token: this.token,
          id: this.id
        }
      }
    },
    created () {
      this.token = this.$route.query.token;
      this.id = this.$route.query.id;
    }
  }
</script>

<style scoped>


</style>
